<template>
  <div class="lending-apy-container">
    <div class="title">借贷APY</div>
    <Table
      className="table-column"
      :columns="columns"
      :data="data"
      :loading="loading"
      border
      disabled-hover
      align="center"
      :span-method="handleSpan"
    >
      <template slot-scope="{ row }" slot="project">
        <div class="project-name-wrapper">
          <strong>{{ row.project }}</strong>
          <div class="chain-wrapper" :marker="row.chainID">
            {{ row.chainID }}
          </div>
        </div>
      </template>
      <template slot-scope="{ row }" slot="updateTime">
        <div
          class="table-cell"
          :style="!row.isNewUpdateTime ? { color: '#e02f02' } : {}"
        >
          {{ row.updateTime }}
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import moment from "moment";
import { convertToCurrencySeparation } from "@/utils/util";

export default {
  name: "lending-apy",
  component: {},
  props: {
    chainID: String,
    isRefresh: Boolean,
  },
  data() {
    return {
      columns: [
        {
          title: " ",
          key: "project",
          width: 100,
          align: "center",
          slot: "project",
        },
        {
          title: "Coin",
          key: "coin",
          align: "center",
        },
        {
          title: "综合APY",
          key: "cycleApy",
          align: "center",
        },
        {
          title: "总存款",
          key: "totalSupply",
          align: "center",
        },
        {
          title: "总借款",
          key: "totalBorrow",
          align: "center",
        },
        {
          title: "存款APY",
          key: "supplySelfApy",
          align: "center",
        },
        {
          title: "借款APY",
          key: "borrowSelfApy",
          align: "center",
        },
        {
          title: "存款奖励APY",
          key: "supplyRewardApy",
          align: "center",
        },
        {
          title: "借款奖励APY",
          key: "borrowRewardApy",
          align: "center",
        },
        {
          title: "奖励币",
          key: "rewardTokenSymbol",
          align: "center",
        },
        {
          title: "最大循环次数",
          key: "cycleMax",
          align: "center",
        },
        {
          title: "抵押比",
          key: "collateralFactor",
          align: "center",
        },
        {
          title: "更新时间",
          key: "updateTime",
          width: 120,
          align: "center",
          slot: "updateTime",
        },
      ],
      data: [],
      loading: false,
      refreshDuration: 0,
    };
  },
  mounted() {
    this.getLendingApyList();
  },

  destroyed() {},

  watch: {
    isRefresh: function (newValue) {
      if (newValue) {
        this.getLendingApyList().then(() => {
          this.$emit("refresh-end", false);
        });
      }
    },
  },

  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (column.key === "project") {
        if (row.ifMerge) {
          return {
            rowspan: row.mergeRowCount,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (column.key === "updateTime") {
        if (rowIndex === 0) {
          return {
            rowspan: this.data.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    getLendingApyList() {
      this.loading = true;
      this.data = [];
      return this.$net
        .get("get_lending_apys", {
          params: {
            chain_id: this.chainID === "ALL" ? "" : this.chainID,
          },
        })
        .then((data) => {
          const { apyProjects, refreshDuration } = data;

          const curTimeStamp = Math.floor(Date.now() / 1000);
          let minUpdateTime = Infinity;
          const resultData = apyProjects.reduce((result, project) => {
            const name = project.name;
            const chainID = project.chainID;

            result = result.concat(
              project.pools.map((pool, index) => {
                const { poolInfo } = pool;
                if (poolInfo.updateTs < minUpdateTime) {
                  minUpdateTime = poolInfo.updateTs;
                }

                return {
                  project: name,
                  chainID,
                  ifMerge: index === 0,
                  mergeRowCount: project.pools.length,
                  coin: pool.poolToken,
                  cycleApy: `${poolInfo.cycleApy.toFixed(2)}%`,
                  totalSupply: `${convertToCurrencySeparation(
                    parseInt(poolInfo.totalSupply)
                  )}`,
                  totalBorrow: `${convertToCurrencySeparation(
                    parseInt(poolInfo.totalBorrow)
                  )}`,
                  supplySelfApy: `${poolInfo.supplySelfApy.toFixed(2)}%`,
                  borrowSelfApy: `${poolInfo.borrowSelfApy.toFixed(2)}%`,
                  supplyRewardApy: `${poolInfo.supplyRewardApy.toFixed(2)}%`,
                  borrowRewardApy: `${poolInfo.borrowRewardApy.toFixed(2)}%`,
                  rewardTokenSymbol: poolInfo.rewardTokenSymbol,
                  cycleMax: poolInfo.cycleMax,
                  collateralFactor: poolInfo.collateralFactor,
                  updateTime: moment(minUpdateTime * 1000).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
                  isNewUpdateTime:
                    curTimeStamp - minUpdateTime <= refreshDuration,
                };
              })
            );

            return result;
          }, []);

          this.data = resultData;
        })
        .catch((e) => {
          console.error(e);
          this.$Message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.ivu-table {
  .ivu-table-cell {
    padding: 0;
  }

  .bold-text-20 {
    font-size: 20px;
    font-weight: bold;
  }

  .bold-text-18 {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>

<style lang="scss" scoped>
@import "@/common/fonts.scss";

.lending-apy-container {
  margin: 40px 0 0 0;
  width: 100%;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 20px 0;
}

.table-cell {
  padding: 0 18px;
}

.title {
  @include fontSize-16;
  @include mediumFont;
  color: #e6e6e6;
  margin: 0 0 16px 0;
}

.project-name-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;

  strong {
    font-size: 16px;
  }
}

.chain-wrapper {
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 12px;

  &[marker="ETH"] {
    background: rgba(27, 27, 27, 0.1);
    color: rgba(37, 62, 111, 0.65);
  }

  &[marker="HECO"] {
    background: rgba(18, 173, 80, 0.1);
    color: rgb(18, 173, 80);
  }

  &[marker="BSC"] {
    background: rgba(206, 161, 0, 0.1);
    color: rgb(206, 161, 0);
  }

  &[marker="POLYGON"] {
    background: rgba(218, 0, 80, 0.1);
    color: rgb(218, 0, 80);
  }
}
</style>
